import React from 'react';
import PropTypes from 'prop-types';

const AudioPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M15.982 4.569L9.271 9.79a1 1 0 0 1-.614.21H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5.657c.223 0 .439.074.614.211l6.711 5.22A1.251 1.251 0 0 0 18 26.444V5.556a1.25 1.25 0 0 0-2.018-.987zm7.746 3.381l1.341-2.111A12.238 12.238 0 0 1 30.475 16c0 4.23-2.145 7.961-5.406 10.161l-1.341-2.111A9.74 9.74 0 0 0 27.976 16a9.74 9.74 0 0 0-4.248-8.05zm-2.953 4.649l1.343-2.115A6.745 6.745 0 0 1 24.975 16a6.743 6.743 0 0 1-2.857 5.516l-1.343-2.115A4.247 4.247 0 0 0 22.476 16a4.247 4.247 0 0 0-1.701-3.401z"
    />
  );
};

AudioPath.propTypes = {
  fill: PropTypes.string,
};

export default AudioPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/audio.jsx